import React from "react";
import { Alert } from "@mui/material";
import { ShieldCheck } from "@phosphor-icons/react";

export interface OverrideAlertProps {
  /** Name of the supervisor who granted the override; blank when they have no name on record */
  grantedByName: string | null;
  /** Display title of the document the override applies to */
  documentTitle: string;
}

/**
 * Announces an active override at the front of the generate flow, before any
 * check has run. Names the approver rather than their role, and names no
 * individual requirement — the override waives all of them.
 *
 * @param props
 * @param props.grantedByName - Name of the supervisor who granted the override
 * @param props.documentTitle - Display title of the document it applies to
 */
const OverrideAlert: React.FC<OverrideAlertProps> = ({ grantedByName, documentTitle }) => (
  <Alert severity="warning" variant="standard" icon={<ShieldCheck size={24} weight="duotone" />}>
    {`${grantedByName ?? ""} approved generating this ${documentTitle} without meeting all requirements. You can continue past any check that doesn't pass.`}
  </Alert>
);

export default OverrideAlert;
